import { render, staticRenderFns } from "./MarketingMessages.vue?vue&type=template&id=d87991fe"
import script from "./MarketingMessages.vue?vue&type=script&lang=js"
export * from "./MarketingMessages.vue?vue&type=script&lang=js"
import style0 from "./MarketingMessages.vue?vue&type=style&index=0&id=d87991fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports